import React from "react";
import { compose } from "redux";

import withTranslations from "../../../../../../hocs/withTranslations";
import { getPeriodLabelKey } from "../../../../../../lib/Plans";

const Period = ({ periods, translate }) => {
  const labelKey = getPeriodLabelKey(periods);
  return labelKey ? translate(labelKey) : null;
};

export default compose(withTranslations)(Period);
